import { createClient } from 'contentful'
import Vue from 'vue'

const ContentfulClient = {
  install (Vue) {
    const client = createClient({
      space: process.env.VUE_APP_CONTENTFUL_SPACE_ID,
      environment: process.env.VUE_APP_CONTENTFUL_ENVIRONMENT,
      accessToken: process.env.VUE_APP_CONTENTFUL_ACCESS_TOKEN
    })
    // this.$contentful in tutte le applicazioni avranno il mio client, che può essere una variabile o una funzione
    Vue.prototype.$contentful = client
  }
}
// autointall
Vue.use(ContentfulClient)
export default ContentfulClient